import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { AbstractControl, FormGroup, Validators } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { FormStateService } from '../form-state.service';
import { ServiceProviderService } from '../../../../Service/Service-providers/service-provider.service';
import { ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-incharge-owner-details',
  templateUrl: './incharge-owner-details.component.html',
  styleUrls: ['./incharge-owner-details.component.scss'],
})
export class InchargeOwnerDetailsComponent implements OnInit {
  form = new FormGroup({});
  model: any = {
    ownerName: '',
    ownerPhone: '',
    ownerEmail: '',
    ownerAdhaar: '',
    inchargeName: '',
    inchargePhone: '',
    inchargeEmail: '',
    inchargeAdhaar: '',
    sponsorName: '',
    sponsorPhone: '',
    sponsorEmail: '',
    sponsorId: '',
    inchargeIdProof: '',
  };

  fields: FormlyFieldConfig[] = [];
  @Output() nextSection = new EventEmitter<void>();
  receivedObject: any;
  isFormPopulated = false;

  constructor(
    private formStateService: FormStateService,
    private api: ServiceProviderService,
    private cdr: ChangeDetectorRef,
    private formStateService1: FormStateService
  ) { }

  @Input() countryId!: string;

  ngOnInit() {
    // issue is with the loadFormData(), and as this is the child compoent loadFormData
    this.loadFormData();
    console.log(this.countryId)
    const userDetailsString = localStorage.getItem('user');
    if (userDetailsString) {
      const userDetails = JSON.parse(userDetailsString);
      this.countryId = userDetails.country?.countryId;
      this.model.countryId = this.countryId;
    }
    this.initializeFields();
  }

  ngOnDestroy() {
    this.saveFormData();
  }
  resetForm() {
    this.form.reset();
    this.model = {};
  }

  initializeFields() {
    console.log('M:', this.countryId)
    if (this.countryId == '1') {
      this.fields = [
        {
          className: 'field col-12',
          template: '<h3>Business owner</h3>',
        },
        {
          fieldGroupClassName: 'p-fluid p-formgrid p-grid',
          fieldGroup: [
            {
              fieldGroupClassName: 'field grid p-fluid',
              fieldGroup: [
                {
                  className: 'field col-6',
                  key: 'ownerName',
                  type: 'input',
                  templateOptions: {
                    label: 'Name of the Owner',
                    placeholder: 'Enter Name',
                    required: true,
                    hideRequiredMarker: true,
                  },
                  hideExpression: () => this.model.countryId === '2',
                },
                {
                  className: 'field col-6',
                  key: 'ownerPhone',
                  type: 'input',
                  templateOptions: {
                    label: 'Phone Number',
                    placeholder: '+91 1234567890',
                    required: true,
                    hideRequiredMarker: true,
                  },
                  validators: {
                    validation: [
                      Validators.required,
                      Validators.pattern(/^\d{10}$/),
                    ],
                  },
                  validation: {
                    messages: {
                      required: 'Phone number is required',
                      pattern: 'Phone number must be exactly 10 digits',
                    },
                  },
                },
              ],
            },
            {
              fieldGroupClassName: 'field grid p-fluid',
              fieldGroup: [
                {
                  className: 'field col-6',
                  key: 'ownerEmail',
                  type: 'input',
                  templateOptions: {
                    label: 'Email',
                    placeholder: 'Enter Email Id',
                    required: true,
                    type: 'email',
                    hideRequiredMarker: true,
                  },
                  validators: {
                    email: {
                      expression: (c: AbstractControl) =>
                        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
                          c.value
                        ),
                      message: (error: any, field: FormlyFieldConfig) =>
                        `${field.formControl?.value} is not a valid email address`,
                    },
                  },
                },
              ],
            },
            {
              className: 'field ',
              key: 'ownerAdhaar',
              type: 'file',
              templateOptions: {
                placeholder: 'Upload Adhaar',
                required: true,
                accept: '.pdf,.jpg,.png',
                description: 'Supported file formats: pdf, jpg, png',
                fileSourceId: 1,
              },
              validation: {
                messages: {
                  required: () => 'Please select a file',
                },
              },
            },

            {
              className: 'field col-12',
              template: '<h3 class="mt-5">Garage Incharge</h3>',
            },
            {
              fieldGroupClassName: 'field grid p-fluid',
              fieldGroup: [
                {
                  className: 'field col-6',
                  key: 'inchargeName',
                  type: 'input',
                  templateOptions: {
                    label: 'Name of the Garage Incharge',
                    placeholder: 'Enter Name',
                    required: true,
                    hideRequiredMarker: true,
                  },
                },
                {
                  className: 'field col-6',
                  key: 'inchargePhone',
                  type: 'input',
                  templateOptions: {
                    label: 'Phone Number',
                    placeholder: 'Enter Phone Number',
                    required: true,
                    type: 'tel',
                    hideRequiredMarker: true,
                  },
                  validators: {
                    validation: [
                      Validators.required,
                      Validators.pattern(/^\d{10}$/),
                    ],
                  },
                  validation: {
                    messages: {
                      required: 'Phone number is required',
                      pattern: 'Phone number must be exactly 10 digits',
                    },
                  },
                },
              ],
            },
            {
              fieldGroupClassName: 'field grid p-fluid',
              fieldGroup: [
                {
                  className: 'field col-6',
                  key: 'inchargeEmail',
                  type: 'input',
                  templateOptions: {
                    label: 'Email',
                    placeholder: 'Enter Email Id',
                    required: true,
                    type: 'email',
                    hideRequiredMarker: true,
                  },
                  validators: {
                    email: {
                      expression: (c: AbstractControl) =>
                        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
                          c.value
                        ),
                      message: (error: any, field: FormlyFieldConfig) =>
                        `${field.formControl?.value} is not a valid email address`,
                    },
                  },
                },
              ],
            },
            {
              className: 'field ',
              key: 'inchargeAdhaar',
              type: 'file',
              templateOptions: {
                placeholder: 'Upload Adhaar',
                required: true,
                accept: '.pdf,.jpg,.png',
                description: 'Supported file formats: pdf, jpg, png',
              },
              validation: {
                messages: {
                  required: () => 'Please select a file',
                },
              },
            },
          ],
        },
      ];
    } else {
      this.fields = [
        {
          fieldGroupClassName: 'p-fluid p-formgrid p-grid',
          fieldGroup: [
            {
              fieldGroupClassName: 'field grid p-fluid',
              fieldGroup: [
                {
                  className: 'field col',
                  key: 'sponsorName',
                  type: 'input',
                  templateOptions: {
                    label: 'Name of the Sponsor',
                    placeholder: 'Enter Name',
                    required: true,
                    hideRequiredMarker: true,
                  },
                },
                {
                  className: 'field col',
                  key: 'sponsorPhone',
                  type: 'input',
                  templateOptions: {
                    label: 'Phone Number',
                    placeholder: 'Enter Phone Number',
                    required: true,
                    type: 'tel',
                    hideRequiredMarker: true,
                  },
                },
              ],
            },
            {
              fieldGroupClassName: 'field grid p-fluid',
              fieldGroup: [
                {
                  className: 'field col-6',
                  key: 'sponsorEmail',
                  type: 'input',
                  templateOptions: {
                    label: 'Email',
                    placeholder: 'Enter Email Id',
                    required: true,
                    type: 'email',
                    hideRequiredMarker: true,
                  },
                  validators: {
                    email: {
                      expression: (c: AbstractControl) =>
                        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
                          c.value
                        ),
                      message: (error: any, field: FormlyFieldConfig) =>
                        `${field.formControl?.value} is not a valid email address`,
                    },
                  },
                },
              ],
            },
            {
              className: 'field col-12',
              key: 'sponsorId',
              type: 'file',
              templateOptions: {
                placeholder: 'Sponsor Id Proof',
                required: true,
                hideRequiredMarker: true,
                accept: '.pdf,.jpg,.png',
                description: 'Supported file formats: pdf, jpg, png',
              },
              validation: {
                messages: {
                  required: () => 'Please select a file',
                },
              },
            },
            {
              className: 'field col-12',
              template: '<h3 class="mt-5">Garage Incharge</h3>',
            },
            {
              fieldGroupClassName: 'field grid p-fluid',
              fieldGroup: [
                {
                  className: 'field col-6',
                  key: 'inchargeName',
                  type: 'input',
                  templateOptions: {
                    label: 'Name of the Garage Incharge',
                    placeholder: 'Enter name',
                    required: true,
                    hideRequiredMarker: true,
                  },
                },
                {
                  className: 'field col-6',
                  key: 'inchargePhone',
                  type: 'input',
                  templateOptions: {
                    label: 'Phone Number',
                    placeholder: 'Enter Phone Number',
                    required: true,
                    type: 'tel',
                    hideRequiredMarker: true,
                  },
                },
              ],
            },
            {
              fieldGroupClassName: 'field grid p-fluid',
              fieldGroup: [
                {
                  className: 'field col-6',
                  key: 'inchargeEmail',
                  type: 'input',
                  templateOptions: {
                    label: 'Email',
                    placeholder: 'Enter Email Id',
                    required: true,
                    type: 'email',
                    hideRequiredMarker: true,
                  },
                  validators: {
                    email: {
                      expression: (c: AbstractControl) =>
                        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
                          c.value
                        ),
                      message: (error: any, field: FormlyFieldConfig) =>
                        `${field.formControl?.value} is not a valid email address`,
                    },
                  },
                },
              ],
            },
            {
              className: 'field col-12',
              key: 'inchargeIdProof',
              type: 'file',
              templateOptions: {
                placeholder: 'Oman Id Proof',
                required: true,
                hideRequiredMarker: true,
                accept: '.pdf,.jpg,.png',
                description: 'Supported file formats: pdf, jpg, png',
                fileSourceId: 1,
              },
              validation: {
                messages: {
                  required: () => 'Please select a file',
                },
              },
            },
          ],
        },
      ];
    }
  }

  populateFormWithServiceProviderDetails(res: any) {
    console.log('Response while populating from owner details component:::', res)
    this.model.ownerName = res.ownerName;
    this.model.ownerPhone = res.ownerPhoneNumber;
    this.model.ownerEmail = res.ownerEmailAddress;
    this.model.ownerAdhaar = res.serviceProviderDocuments?.find(
      (doc: any) => doc.documentTypeId === 7
    )?.fileId;

    this.model.inchargeName = res.garageInChargeName;
    this.model.inchargePhone = res.garageInChargePhoneNumber;
    this.model.inchargeEmail = res.garageInChargeEmailAddress;
    this.model.inchargeAdhaar = res.serviceProviderDocuments?.find(
      (doc: any) => doc.documentTypeId === 8
    )?.fileId;

    this.model.sponsorName = res.sponsorName || '';
    this.model.sponsorPhone = res.sponsorPhoneNumber || '';
    this.model.sponsorEmail = res.sponsorEmailAddress || '';

    this.form.patchValue(this.model);
    this.isFormPopulated = true;
    this.formStateService1.setFormData('owner-details', this.model);
    this.initializeFields()

  }



  loadFormData() {
    const savedData = this.formStateService.getFormData('owner-details');
    if (savedData) {
      this.model = { ...savedData };
      // Patch the form with saved data
      this.isFormPopulated = true
      this.form.patchValue(this.model);
    }
  }

  saveFormData() {
    const formData = { ...this.model };
    this.formStateService.setFormData('owner-details', formData);
  }

  submit() {
    if (this.form.valid) {
      this.saveFormData();
      const transformedDataOI = this.createFinalObject(this.form.value);
      this.formStateService.setOwnerInchargeDetails(transformedDataOI);

      // Store owner details separately
      const ownerDetails = {
        ownerName: this.model.ownerName,
        ownerPhoneNumber: this.model.ownerPhone,
        ownerEmailAddress: this.model.ownerEmail,
      };
      this.formStateService.setOwnerDetails(ownerDetails);

      const data = this.formStateService.getCombinedData();
      console.log('Combined data', data);
      this.nextSection.emit();
    }
  }

  createFinalObject(ownerInchargeData: any): any {
    return {
      sponsorName: ownerInchargeData.sponsorName || null,
      ownerName: ownerInchargeData.ownerName || null,
      ownerPhoneNumber: ownerInchargeData.ownerPhone || null,
      sponsorPhoneNumber: ownerInchargeData.sponsorPhone || null,
      sponsorEmailAddress: ownerInchargeData.sponsorEmail || null,
      ownerEmailAddress: ownerInchargeData.ownerEmail || null,
      garageInChargeName: ownerInchargeData.inchargeName,
      garageInchargeEmailAddress: ownerInchargeData.inchargeEmail,
      garageInChargePhoneNumber: ownerInchargeData.inchargePhone,
      documents: [
        {
          documentTypeId: 7, // Owner Id proof
          documentNumber: '',
          fileId: ownerInchargeData.ownerAdhaar || ownerInchargeData.sponsorId,
        },
        {
          documentTypeId: 8, // Incharge Id proof
          documentNumber: '',
          fileId:
            ownerInchargeData.inchargeAdhaar ||
            ownerInchargeData.inchargeIdProof,
        },
      ],
    };
  }
}
